import { render, staticRenderFns } from "./PaymentCorporateAccounts.vue?vue&type=template&id=f83d8ce4&"
import script from "./PaymentCorporateAccounts.vue?vue&type=script&lang=js&"
export * from "./PaymentCorporateAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports